// extracted by mini-css-extract-plugin
export default {"link":"HeadPage_link__1YKLU","lastLink":"HeadPage_lastLink__OmkHY"};